<template>
  <div class="bigBox">
    <div class="topContent">
      <span class="query_text">终端id:</span>
      <a-input placeholder="请输入终端id" v-model:value="search.terminalID" />
      <span class="query_text">变电站名称：</span>
      <a-space direction="vertical">
        <a-select v-model:value="search.bdzName" :options="options" :maxTagCount="1"
          :field-names="{ label: 'substationName', value: 'substationId' }" show-search :filter-option="filterOption"
          :autoClearSearchValue="false" mode="multiple" :size="size" placeholder="请选择变电站" style="width: 200px"
          @change="handleChange"></a-select>
      </a-space>
      <span class="query_text">隔刀厂家：</span>
      <a-input placeholder="请输入隔刀厂家" v-model:value="search.vender" />
      <span class="query_text">隔刀型号：</span>
      <a-input placeholder="请输入隔刀型号" v-model:value="search.version" />
      <a-button type="primary" class="queryBtn" @click="onSubmit">
        查询
      </a-button>
      <a-button class="queryBtn" @click="onReset">
        重置
      </a-button>

    </div>
    <div class="bottomContent" ref="content">
      <a-table :columns="columns" :data-source="dataSource" :pagination="pagination" @change="changePage"
        :row-class-name='rowClassName' :scroll="{ y: heightWidth }">
        <template v-slot:bodyCell="{ record, column, text }">
          <!-- <template v-if="column.dataIndex == 'online'">
            <img v-if="record.online == 1" src="@/style/img/在线.png" />
            <img v-else-if="record.online == 2" src="@/style/img/离线.png" />
            <img v-else-if="record.online == 3" src="@/style/img/故障状态.png" />
            <span v-else></span>
          </template> -->
          <template v-if="column.dataIndex === 'serviceType'">
             <div v-if="record.serviceType == '1'">站端</div>
             <div v-if="record.serviceType == '2'">便携端</div>
            </template>
          <template v-if="column.dataIndex === 'closeCurve'">
            <!--  :action="`/yunDuanUrl/dmsm-service-cloud/algorithm/uploadFile?fileName=${UPdata1.fileName}&fileType=${UPdata1.fileType}&substation=${record.substation}&substationName=${record.substationName}&termID=${record.termID}`" -->
            <a-upload :customRequest="customRequest" name="file" method="post" :data="{ record, column }" :headers="headers"
              @change="uploadChange">
              <a-button>
                <upload-outlined></upload-outlined>
                <span style="color: #fff;display:block;overflow-wrap:break-word;width: auto;white-space: pre-wrap;"
                  v-if="text">{{ text }}</span>
                <span v-else style="color: #119FFF">部署</span>
                <!-- {{ text ? `<span>${text}</span>` : "部署" }} -->
              </a-button>
            </a-upload>
          </template>
          <template v-if="column.dataIndex === 'openCurve'">
            <a-upload :customRequest="customRequest" name="file" method="post" :headers="headers" :data="{ record, column }"
              @change="uploadChange">
              <a-button>
                <upload-outlined></upload-outlined>
                <span style="color: #fff;display:block;overflow-wrap:break-word;width: auto;white-space: pre-wrap;"
                  v-if="text">{{ text }}</span>
                <span v-else style="color: #119FFF">部署</span>
              </a-button>
            </a-upload>
          </template>
          <template v-if="column.dataIndex === 'diagProgram'">
            <a-upload :customRequest="customRequest" name="file" method="post" :headers="headers" :data="{ record, column }"
              @change="uploadChange">
              <a-button>
                <upload-outlined></upload-outlined>
                <span style="color: #fff;display:block;overflow-wrap:break-word;width: auto;white-space: pre-wrap;"
                  v-if="text">{{ text }}</span>
                <span v-else style="color: #119FFF">部署</span>
              </a-button>
            </a-upload>
          </template>
          <template v-if="column.dataIndex === 'bestNewDiagReport'">
            <a-upload :customRequest="customRequest" name="file" method="post" :headers="headers" :data="{ record, column }"
              @change="uploadChange">
              <a-button>
                <upload-outlined></upload-outlined>
                <span style="color: #fff;display:block;overflow-wrap:break-word;width: auto;white-space: pre-wrap;"
                  v-if="text">{{ text }}</span>
                <span v-else style="color: #119FFF">部署</span>
              </a-button>
            </a-upload>
          </template>
          <template v-if="column.dataIndex === 'springCurve'">
            <a-upload :customRequest="customRequest" name="file" method="post" :headers="headers" :data="{ record, column }"
              @change="uploadChange">
              <a-button>
                <upload-outlined></upload-outlined>
                <span style="color: #fff;display:block;overflow-wrap:break-word;width: auto;white-space: pre-wrap;"
                  v-if="text">{{ text }}</span>
                <span v-else style="color: #119FFF">部署</span>
              </a-button>
            </a-upload>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script >
// 算法维护页面
const columns = [{
  title: '终端id',
  dataIndex: 'termID',
  key: 'termID',
}, 
// {
//   title: '终端状态',
//   dataIndex: 'online',
//   key: 'online'
// },
{
  title: 'clientID',
  dataIndex: 'clientID',
  key: 'clientID'
},
{
  title: '服务类型',
  dataIndex: 'serviceType',
  key: 'serviceType'
},
{
  title: '省份',
  dataIndex: 'provinceName',
  key: 'provinceName'
},
{
  title: '城市',
  dataIndex: 'cityName',
  key: 'cityName'
},
{
  title: '基层单位',
  dataIndex: 'companyName',
  key: 'companyName',
  width: 200,
},
{
  title: '变电站名称',
  dataIndex: 'substation',
  key: 'substation'
},
{
  title: '隔刀厂家',
  dataIndex: 'switchFactor',
  key: 'switchFactor'
},
{
  title: '隔刀型号',
  dataIndex: 'switchModel',
  key: 'switchModel'
},
{
  title: '分合次数',
  dataIndex: 'switchNum',
  key: 'switchNum',
  sorter: true,
  width: 100,
  align: 'center',
},
{
  title: '合闸指纹',
  dataIndex: 'closeCurve',
  key: 'closeCurve',
},
{
  title: '分闸指纹',
  dataIndex: 'openCurve',
  key: 'openCurve'
},
{
  title: '弹簧指纹',
  dataIndex: 'springCurve', 
  key: 'springCurve'
},
{
  title: '诊断程序',
  dataIndex: 'diagProgram',
  key: 'diagProgram'
},
// {
//   title: '诊断报告',
//   dataIndex: 'bestNewDiagReport',
//   key: 'bestNewDiagReport'
// },
{
  title: '最新数据文件',
  dataIndex: 'bestNewDataFile',
  key: 'bestNewDataFile'
},
];

import { message } from 'ant-design-vue';
import { getAlgorithmList, bdzNumber, upload } from '../../api/algorithmMaintain'
export default {
  data() {
    return {
      columns,
      size: 'middle',
      search: {
        terminalID: "",
        bdzName: [],
        vender: "",
        version: "",
      },
      options: [],
      uploadUrl: '/yunDuanUrl/dmsm-service-cloud/algorithm/uploadFile',
      // UPdata1:{  //上传的参数
      //   fileType:1, //1:合闸指纹
      //   fileName:"测试表",
      // },
      // UPdata2:{  
      //   fileType:2, //2:分闸指纹
      //   fileName:"", //上传文件原文件名
      //   substation:"", //变电站ID
      //   substationName:"", //变电站名称
      //   termID:"",  //终端id
      // },
      // UPdata3:{
      //   fileType:3, //3:诊断程序
      //   fileName:"",
      // },
      // UPdata4:{ 
      //   fileType:4, //4:诊断报告
      //   fileName:"",
      // },
      fileList: [],  //上传列表
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': localStorage.getItem("token") || ''
      },
      heightWidth: 100,
      pagination: { //分页设置
        //每条数量
        current: 1,
        total: '',
        pagesize: 10,
        //可改变本页的条数
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total => `共${total}条`)
      },
      sort: '', //排序参数
      orderByColumn: '',
      orderList:[], //排序参数
      dataSource: [],//表格数据
    }
  },
  mounted() {
    this.getBdzData()
    this.onWidnowResize();
    addEventListener('resize', this.onWidnowResize, false)
  },
  beforeUnmount() {
    removeEventListener('resize', this.onWidnowResize)
  },
  methods: {
    customRequest(info) {
      let doc = info.file.name.split('.');
      let name = doc[0].split('_');
      let type = '';
      switch (info.data.column.title) {
        case '合闸指纹':
          if (name[0] != info.data.record.termID) {
            this.$message.info("选择的终端id和上传文件的终端id不一致!");
            return;
          } else if(name[name.length - 1] + '.xls' != 'H.xls') {
            this.$message.info("合闸指纹文件的后缀必须是H.xls!");
            return;
          }
          type = 1;
          break;
        case '分闸指纹':
        if (name[0] != info.data.record.termID) {
            this.$message.info("选择的终端id和上传文件的终端id不一致!");
            return;
          } else if(name[name.length - 1] + '.xls' != 'F.xls') {
            this.$message.info("合闸指纹文件的后缀必须是F.xls!");
            return;
          }
          type = 2;
          break;
        case '弹簧指纹':
        if (name[0] != info.data.record.termID) {
            this.$message.info("选择的终端id和上传文件的终端id不一致!");
            return;
          } else if(name[name.length - 1] + '.xls' != 'T.xls') {
            this.$message.info("合闸指纹文件的后缀必须是T.xls!");
            return;
          }
          type = 0;
          break;
          case '诊断程序':
        if (name[0] != info.data.record.termID) {
            this.$message.info("选择的终端id和上传文件的终端id不一致!");
            return;
          } else if(name[name.length - 1] + '.dll' != 'D.dll') {
            this.$message.info("合闸指纹文件的后缀必须是D.dll!");
            return;
          }
          type = 3;
          break;
        default:
        if (name[0] != info.data.record.termID) {
            this.$message.info("选择的终端id和上传文件的终端id不一致!");
            return;
          } else if(name[name.length - 1] + '.doc' != 'ZD.doc') {
            this.$message.info("合闸指纹文件的后缀必须是ZD.doc!");
            return;
          }
          type = 4;
      }
      let query = {
        fileName: doc[0],
        fileType: type,
        substation: info.data.record.substation,
        substationName: info.data.record.substationName,
        termID: info.data.record.termID,
        clientID: info.data.record.clientID,
      }
      upload(query,{uploadFile:info.file}).then(res=>{
          if(res.success){
            message.info(`${res.data.info}`);
            this.getTableData()
          }
        }).catch((err) => {
            this.$message.info("上传失败");
            this.$message.info(err);
          });
    },
    //变电站数据
    getBdzData() {

      bdzNumber().then((res) => {
        if (res.success) {
          this.options = res.data
          //默认选中
          // this.search.bdzName = res.data.map(el => {
          //   return el.substationId
          // });
          this.getTableData()
        }
      })
    },
    //表格数据
    getTableData() {
      let params = {
        companyName: this.search.terminalID,
        substationIds: this.search.bdzName.join(","),
        switchFactor: this.search.vender,
        switchModel: this.search.version,
        pagenum: this.pagination.current,
        pagesize: this.pagination.pagesize,
        orderList:this.orderList
      }
       // orderByColumn: this.orderByColumn,
        // sort: this.sort
      // console.log(query,'分页列表数据查询')
      getAlgorithmList(params).then((res) => {
        this.dataSource = res.data.rows
        this.pagination.total = res.data.total
      })
    },
    //下拉框事件
    handleChange(value) {
      this.search.bdzName = value
      // console.log(...this.search.bdzName,`Selected: ${value}`);
    },
    filterOption(inputValue, option) {
      return option.substationName.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
    },
    //分页列表数据查询
    onSubmit() {
      this.pagination.current = 1;
      this.getTableData()
    },
    //重置
    onReset() {
      // search.bdzName
      this.search = {
        terminalID: "",
        bdzName: [],
        vender: "",
        version: '',
      }
      this.getBdzData();
    },
    // 表格样式（斑马）
    rowClassName(_record, index) {
      return index % 2 === 0 ? 'table-striped' : null;
    },
    //调整表格大小
    onWidnowResize() {
      let content = this.$refs.content.clientHeight - 40 - 64;
      this.heightWidth = content;
      let container = document.querySelector('.ant-table-body');
      container.style.height = content + 'px';
    },
    //排序或者换页时调用
    changePage(page, _, sort) {
      if (page.current != this.pagination.current || page.pageSize != this.pagination.pagesize) {
        this.pageChange(page.current, page.pageSize)
      }
      else {
        this.changeSort(sort);
      }
    },
    //换页清空选、重新获取table值
    pageChange(current, pagesize) {
      this.pagination.current = current;
      this.pagination.pagesize = pagesize;
      this.getTableData();
    },
    //排序后，设置排序结构
    changeSort(sort) {
      this.orderList = []
      if (sort.order == "ascend") {
        this.orderList.push({
          sort:"ASC",
          orderByColumn:sort.column.dataIndex
        })
        // this.sort = "ASC"
        // this.orderByColumn = sort.column.dataIndex;
      } else if (sort.order == "descend") {
        this.orderList.push({
          sort:"DESC",
          orderByColumn:sort.column.dataIndex
        })
        // this.sort = "DESC"
        // this.orderByColumn = sort.column.dataIndex;
      } else if (sort.order == undefined) {
        this.orderList=[]
        // this.orderByColumn = ""
        // this.sort = ""
        // console.log('取消')
      
      }
      this.getTableData();
      // console.log('sort',sort)
    },
    //文件上传
    uploadChange(info) {
      // if (info.file.status !== 'uploading') {
      //  debugger
      // }
      if (info.file.status === 'done') {
        // debugger
        let file = info.file.originFileObj;
        this.UPdata1.fileName = info.file.name
        let form = new FormData();
        form.append('uploadFile', file);
        upload(form).then(res => {
          if (res.success) {
            message.success(`${info.file.name} 文件上传成功`);
          }
        }).catch((err) => {
          this.$message.info("上传失败");
          this.$message.info(err);
        });
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 文件上传失败`);
      }
    },
  }
}
</script>

<style scoped>
.bigBox {
  width: 100%;
  height: 100%;
}

.topContent {
  /* width: 100%; */
  height: 80px;
  line-height: 80px;
  background: linear-gradient(144deg, #25404e 0%, #2f5c74 100%);
  border: 2px solid #2b76a1;
  margin: 0 10px;
}

.query_text {
  color: #FFF;
  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  margin-right: 10px;
  margin-left: 50px;
}

::v-deep .ant-input {
  width: 200px;
  margin: 0 8px 8px 0;
}

::v-deep .ant-select-multiple .ant-select-selection-item {
  background: #0fd3c6 !important;
  border: 1px solid #0fd3c6 !important;
}

.queryBtn {
  color: #FFF !important;
  margin-left: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  line-height: 14px;
  background: linear-gradient(-45deg, #0c96b1 0%, #0fbca1 100%);
  border: 1px solid;
  border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
}

.bottomContent {
  height: calc(100% - 100px);
  /* margin: 20px; */
  margin: 10px 10px 20px 10px;
  background: linear-gradient(-31deg, #3a5e78 0%, #15273f 100%);
  border: 2px solid;
  border-image: linear-gradient(0deg, #3f83a8 0%, #2b76a1 100%) 2 2;
}

/* 表头排序的样式 */
::v-deep .ant-table-filter-column {
  justify-content: space-around !important;
}

::v-deep .ant-table-filter-trigger:hover {
  color: #FFF;
}

/* 排序点击选中背景颜色 */
::v-deep .ant-dropdown-menu-item-selected {
  background-color: none !important;
}

::v-deep .ant-table.ant-table-bordered>.ant-table-container {
  border-left: none !important;
  /* border-image: linear-gradient(0deg, #375E79 0%, #2b76a1 100%) 1 1; */
}

::v-deep .ant-table-content>table {
  border-top: none !important;
  /* border-image: linear-gradient(0deg, #375E79 0%, #2b76a1 100%) 1 1; */
}

::v-deep thead.ant-table-thead {
  background: none !important;
}

::v-deep .ant-table-content>table>thead>tr>th {
  /* color: #08decf; */
  border-right: none !important;
  /* border-image: llinear-gradient(0deg, #375E79 0%, #2b76a1 100%) 1 1; */
}

::v-deep .ant-table.ant-table-bordered>.ant-table-container>.ant-table-content>table>thead>tr>th::before {
  background-color: #19A4B0 !important;
}

::v-deep .ant-table-thead>tr>th {
  height: 40px !important;
  border-bottom: 1px solid #1ba7b3 !important;
}

::v-deep .ant-table-content>table>tbody>tr>td {
  border-right: none !important;
  /* border-bottom:1px solid  !important; */
  /* border-image: linear-gradient(0deg, #375E79 0%, #2b76a1 100%) 1 1; */
}

/* 上传按钮的样式 */
::v-deep .ant-btn {
  background-color: transparent;
  color: #1890ff;
}

/* 头部右小边框样式 */
::v-deep .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  background-color: #19A4B0 !important;
  height: 1em !important;
  top: 60% !important;
  padding-bottom: 5px !important;
}
</style>